import { render } from "./ReportsPBI.vue?vue&type=template&id=13d6cba1"
import script from "./ReportsPBI.vue?vue&type=script&lang=js"
export * from "./ReportsPBI.vue?vue&type=script&lang=js"

import "./ReportsPBI.vue?vue&type=style&index=0&id=13d6cba1&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__